import React from 'react';
import PropTypes from 'prop-types';
import css from './CancelModal.scss';
import { SFEntityID, SFNotification } from 'utils/types';
import { Button, Icon } from 'semantic-ui-react';
import Modal from 'react-modal';
import { apiErrorMessage } from 'utils/request';
import { cancelAppointment } from 'utils/appointments';
import CancelDescription from "./CancelDescription";
import { getDateFormat } from "../utils/time";

export default class CancelModal extends React.Component {

  constructor() {
    super();
    this.state = {
      hasChosen: false,
      cancelAllAppointments: false,
      isCanceling: false,
      cancelDescription: ''
    };

    // Reference: http://reactcommunity.org/react-modal/accessibility/#app-element
    Modal.setAppElement(document.getElementById('main-center'));
  }

  onConfirmCancelAppointment() {
    const { appointmentId, notification, onClose, onSuccess } = this.props;
    const time = this.time("YYYY-MM-DD HH:mm");
    this.setState({isCanceling: true});
    return cancelAppointment(appointmentId, time, this.state.cancelDescription, this.state.cancelAllAppointments)
      .then(onSuccess)
      .catch(e => notification.error(apiErrorMessage(e)))
      .then(() => onClose()) // Close modal regardless of the result
  }

  onCancelDescriptionChanged = (e) => {
    this.setState({cancelDescription: e.target.value});
  }

  time(format) {
    return this.props.startDate.format(format);
  }

  get cancelAppointmentText() {
    if ( !this.props.recurring || (this.state.hasChosen && !this.state.cancelAllAppointments) ) {
      const time = this.props.startDate.format(getDateFormat("dateTimeDisplayFormat"));
      return `Are you sure you want to cancel your appointment with ${this.props.ownerName} on ${time}?`
    } else if ( this.state.hasChosen && this.state.cancelAllAppointments ) {
      return `Are you sure you want to cancel all remaining appointments with ${this.props.ownerName}?`
    } else return `This is a recurring appointment. What do you want to cancel?`;
  }

  get cancelSingleApptButton() {
    return !this.state.hasChosen && this.props.recurring
      ? (
        <Button
          className='single-button'
          onClick={() => this.setState({hasChosen: true, cancelAllAppointments: false})}>
          Just this one
        </Button>
      ) : null;
  }

  get cancelAllApptsButton() {
    return !this.state.hasChosen && this.props.recurring
      ? (
        <Button
          className='all-button'
          onClick={() => this.setState({hasChosen: true, cancelAllAppointments: true})}>
          All of them
        </Button>
      ) : null;
  }

  get neverMindButton() {
    return (this.state.hasChosen || !this.props.recurring) && !this.state.isCanceling
      ? <Button className='nvm-button' onClick={this.props.onClose}>Keep It</Button>
      : null;
  }

  get confirmButton() {
    return this.state.hasChosen || !this.props.recurring
      ? (
        <Button
          className={css['confirm-button']}
          disabled={this.state.isCanceling}
          onClick={this.onConfirmCancelAppointment.bind(this)}>
          <Icon name={this.state.isCanceling ? 'spinner' : 'checkmark'} loading={this.state.isCanceling} />
          {' '}
          {this.state.isCanceling ? "Canceling" : "Cancel It"}
        </Button>
      ) : null;
  }

  get cancelDescription() {
    return this.state.hasChosen || !this.props.recurring ?
      <CancelDescription
        value={this.state.cancelDescription}
        onChange={this.onCancelDescriptionChanged} />
      : null;
  }

  get modalActions() {
    return (
      <div className={css['actions']}>
        {this.cancelSingleApptButton}
        {this.cancelAllApptsButton}
        {this.neverMindButton}
        {this.confirmButton}
      </div>
    );
  }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        onRequestClose={this.props.onClose}
        className={css['modal']}
        overlayClassName={css['overlay']}>
        <div className={`${css['content']} modal-content`}>
          <p className={css['cancel-text']}>{this.cancelAppointmentText}</p>
          {this.cancelDescription}
        </div>
        {this.modalActions}
      </Modal>
    );
  }
}

CancelModal.propTypes = {
  appointmentId: SFEntityID.isRequired,
  notification: SFNotification.isRequired,
  ownerName: PropTypes.string.isRequired,
  startDate: PropTypes.object.isRequired,
  recurring: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};
